import { render, staticRenderFns } from "./completeProblem.vue?vue&type=template&id=148a4d0a&scoped=true&"
import script from "./completeProblem.vue?vue&type=script&lang=js&"
export * from "./completeProblem.vue?vue&type=script&lang=js&"
import style0 from "./completeProblem.vue?vue&type=style&index=0&id=148a4d0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a4d0a",
  null
  
)

export default component.exports